export const ADD_PROFESSION_NAME_AND_EXPERIENCE = 'Select your profession and years of experience.';

export const ADD_PROFESSION_NAME = 'Select your profession.';

export const ADD_PROFESSION_EXPERIENCE = 'Add years of experience for your profession.';

export const ADD_LOCATION = 'Add your location.';

export const ADD_AN_INDUSTRY = 'Add some industry experience.';

export const ADD_MORE_THAN_ONE_INDUSTRY = 'Add any additional industry experience if you have it.';

export const ADD_A_COLLEGE_DEGREE = 'College educated? Make sure you add your degrees.';

export const ADD_A_CERTIFICATION = 'Make sure you add any relevant certifications.';

export const ADD_A_SKILL = 'Add your professional skills.';

export const ADD_AT_LEAST_TEN_SKILLS = 'Make sure you add as many relevant skills as possibie. We recommend at least 10.';

export const ADD_AN_ACCOMPLISHMENT = 'Employers want to know about your success in the workplace. Add some accomplishments.';

export const ADD_AT_LEAST_THREE_ACCOMPLISHMENTS = 'We recommend at least 3 accomplishments to showcase your professional success.';

export const ADD_BIO = 'Employers want to get to know you. Add a bio to improve your score.';

export const ADD_A_COMPANY = 'Describe the companies you\'ve worked for.';

export const ADD_MORE_THAN_ONE_COMPANY = 'We recommend you describe at least 2 companies you\'ve worked for.';
